import { PureComponent, CSSProperties } from 'react'
import { DocumentItem } from '../generic'
import ConfirmationDialog from '../../LEGACY/ConfirmationDialog'
import { Add, Button, FormCard } from '@lmc/ui-kit'

interface CarePlanDocumentsProps {
  carePlan: {
    documents?: Array<string>
  }
  documents?: any
  onCreate?: () => void
  onDelete?: (documentId: string) => void
  onEdit?: (documentId: string) => void
  style?: CSSProperties
}

interface CarePlanDocumentsState {
  documentToDelete: string | null
}

export default class CarePlanDocuments extends PureComponent<
  CarePlanDocumentsProps,
  CarePlanDocumentsState
> {
  state: CarePlanDocumentsState = {
    documentToDelete: null,
  }

  openDialog = (id: string) => this.setState({ documentToDelete: id })

  closeDialog = () => this.setState({ documentToDelete: null })

  handleDelete = () => {
    if (this.props.onDelete && this.state.documentToDelete) {
      this.props.onDelete(this.state.documentToDelete)
    }
    this.closeDialog()
  }

  getCarePlanDocuments = (): Array<any> => {
    const { carePlan, documents } = this.props
    return carePlan.documents && carePlan.documents.length
      ? documents.filter((doc: { id: string }) =>
          carePlan.documents!.includes(doc.id)
        )
      : []
  }

  render() {
    const { carePlan, documents, onCreate, onEdit, style } = this.props

    if (!carePlan || !documents) return null

    const carePlanDocuments = this.getCarePlanDocuments()

    const hasCarePlanDocuments = !!carePlanDocuments?.length

    return (
      <div
        style={{
          ...styles.wrapper,
          ...style,
        }}
      >
        <FormCard
          title="Documents"
          rightChildren={
            onCreate && (
              <Button
                type="button"
                variant="text"
                icon={<Add />}
                onClick={() => onCreate()}
              >
                Upload Documents
              </Button>
            )
          }
        >
          {hasCarePlanDocuments ? (
            <>
              {carePlanDocuments.map((document) => (
                <DocumentItem
                  data={document}
                  key={document.id}
                  onDelete={this.openDialog}
                  onEdit={onEdit}
                  readOnly={!onEdit}
                  type={onEdit ? 'edit' : 'create'}
                />
              ))}
              <div />
            </>
          ) : null}
        </FormCard>
        <ConfirmationDialog
          confirmationType="warning"
          isOpen={!!this.state.documentToDelete}
          onCancel={this.closeDialog}
          onConfirmation={this.handleDelete}
        >
          <div>
            Are you sure you want to delete this document? If you go ahead, it
            can’t be undone. Once it’s gone, it’s gone for good!
          </div>
        </ConfirmationDialog>
      </div>
    )
  }
}

const styles = {
  wrapper: {
    paddingBottom: 30,
  },
}
